import * as React from "react";
import { ChevronRightIcon } from "../../../components/icons";
import AssistantMark from "./AssistantMark";

export interface DraftEmptyStateProps {
  /** From the adapter: what this host's assistant is actually good for. */
  suggestions: readonly string[];
  onPick: (text: string) => void;
  /** No model chosen yet, or a turn in flight. */
  disabled?: boolean;
}

/**
 * A new chat. One sentence on what the assistant does and a few things to try,
 * because a blank pane with a text box asks the user to guess what is possible.
 */
const DraftEmptyState = ({ suggestions, onPick, disabled = false }: DraftEmptyStateProps) => (
  <div className="flex min-h-full flex-col justify-center gap-5 px-3.5 py-6">
    <div className="flex flex-col items-center gap-2 text-center">
      <AssistantMark size={36} />
      <h6 className="m-0 pt-1 text-h6 text-strong">Draft with Jylo</h6>
      <p className="m-0 max-w-[260px] text-body2 text-muted-foreground">
        Ask me to read, edit or analyse what you have open, or pick a place to start.
      </p>
    </div>

    {suggestions.length > 0 && (
      <div className="flex flex-col gap-1.5">
        {suggestions.map((text) => (
          <button
            key={text}
            type="button"
            disabled={disabled}
            onClick={() => onPick(text)}
            className="flex min-h-11 items-center justify-between gap-2 rounded-[16px] border border-border bg-card px-3 py-2 text-left text-[12.5px] leading-[1.4] text-foreground outline-none hover:border-input hover:bg-grey-50 focus-visible:ring-[3px] focus-visible:ring-ring/40 disabled:pointer-events-none disabled:text-disabled"
          >
            {text}
            <ChevronRightIcon className="size-4 flex-none text-disabled" />
          </button>
        ))}
      </div>
    )}
  </div>
);

export default DraftEmptyState;
